import React from 'react';
import GalleryPickerComponent from './GalleryPickerComponent';

export default function ImageInputComponent(props) {
    return <GalleryPickerComponent extensions={['svg', 'jpg', 'jpeg', 'png', 'bmp']} {...props}/>
}
